import React, { useState, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  Switch,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  SpButton,
  SpH5,
} from 'components/DesignKit';

type Props = {
  internalAccount: Object,
  submit: Function,
  openModal: Function,
};

const Kios = (props: Props) => {
  const {
    internalAccount,
    submit,
    openModal,
  } = props;

  const [, forceUpdate] = useState();
  const [enableKiosk, setEnableKiosk] = useState(internalAccount?.enableKiosk ? internalAccount?.issuerActive : false);
  const [disabled, setDisabled] = useState(true);
  const simpleValidator = useRef(new SimpleReactValidator());

  simpleValidator.current.purgeFields();

  const updateKios = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    submit({
      enableKiosk,
    });
  };

  const reset = () => {
    setEnableKiosk(internalAccount?.enableKiosk ? internalAccount?.issuerActive : false);
    setDisabled(true);
    openModal(false);
  };

  return (
    <>
      <div>
        <Row>
          <Col span={6} className="mb-2 mt-4">
            <SpH5>Enable or disable kiosk experience for your business</SpH5>
            <Switch
              checked={enableKiosk}
              className="ml-2"
              onChange={val => {
                setEnableKiosk(val);
                setDisabled(false);
                openModal(true);
              }}
            />
          </Col>
        </Row>
        <Row className="mt-4" style={{ marginLeft: '-15px' }}>
          <Col span={2}>
            <Button
              type="link"
              onClick={reset}
              disabled={disabled}
            >
              Reset
            </Button>
          </Col>
          <Col span={2}>
            <SpButton
              type="primary"
              shape="round"
              disabled={disabled}
              onClick={updateKios}
            >
              Update
            </SpButton>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default React.memo(Kios);
